egtoMustMatch.$inject = [];

export function egtoMustMatch() {
    var directive = {
        require: 'ngModel',
        link: link,
        restrict: 'A'
    };
    return directive;

    function link(scope, element, attrs, ngModel) {
        var valueToMatch = scope.$eval(attrs.egtoMustMatch);
        ngModel.$validators.mustMatch = mustMatch;

        scope.$watch(attrs.egtoMustMatch, function (newValueToMatch) {
            valueToMatch = newValueToMatch;
            ngModel.$validate();
        });

        function mustMatch(modelValue, viewValue) {
            return valueToMatch === viewValue;
        }
    }
}